import React from "react";

const EmptyTableIcon = () => {
  return (
    <svg width="184" height="118" viewBox="0 0 184 118" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1427_1455)">
        <path
          d="M25.875 83.5C9.85688 87.0947 0 91.9916 0 97.3884C0 108.421 41.1898 117.364 92 117.364C142.81 117.364 184 108.421 184 97.3884C184 91.9916 174.143 87.0947 158.125 83.5V92.208C158.125 98.2664 154.33 103.232 149.644 103.232H34.3563C29.67 103.232 25.875 98.2635 25.875 92.208V83.5Z"
          fill="black"
          fillOpacity="0.06"
        />
        <path
          d="M119.637 48.8153C119.637 44.2352 122.495 40.4541 126.04 40.4512H158.125V92.208C158.125 98.2663 154.33 103.232 149.644 103.232H34.3562C29.67 103.232 25.875 98.2635 25.875 92.208V40.4512H57.96C61.5049 40.4512 64.3626 44.2266 64.3626 48.8067V48.8695C64.3626 53.4496 67.252 57.148 70.794 57.148H113.206C116.748 57.148 119.637 53.4154 119.637 48.8353V48.8153Z"
          fill="black"
          fillOpacity="0.04"
          stroke="black"
          strokeOpacity="0.15"
        />
        <path
          d="M158.125 40.7663L128.955 7.94356C127.555 5.70629 125.511 4.35366 123.358 4.35366H60.6424C58.489 4.35366 56.4449 5.70629 55.0448 7.94071L25.875 40.7692"
          stroke="black"
          strokeOpacity="0.15"
        />
      </g>
      <defs>
        <clipPath id="clip0_1427_1455">
          <rect width="184" height="117" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default EmptyTableIcon;
